import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { PmaxPreviewData } from '../../../../../../../models/google-template/preview-interfaces/pmax-preview-data.interface';
import { MobileFrameComponent } from '../../../preview-common/mobile-frame/mobile-frame.component';

const HOTELS = 'assets/images/pmax-preview-hotels/';

/**
 * Performance Max interstitial on the Display Network (mobile): brand row on
 * top, one hotel card, then close and CTA buttons. The hotel card is a static
 * placeholder; it is not a template field.
 */
@Component({
  selector: 'app-pmax-display-mobile-03',
  imports: [CommonModule, MobileFrameComponent],
  templateUrl: './display-mobile-03.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './display-mobile-03.component.scss'
})
export class PmaxDisplayMobile03PreviewComponent {
  @Input() data!: PmaxPreviewData;

  readonly hotel = {
    image: HOTELS + 'lanterna.jpg',
    title: 'Lanterna Resort',
    subtitle: 'Najbolja cijena',
  };

  get longHeadline(): string {
    return this.data.longHeadlines[0] || 'Your long headline appears here';
  }

  get ctaText(): string {
    return this.data.ctaText || 'Book now';
  }
}
